import { ImageComponent } from "@tm/static";
import { FormattedText } from "@tm/ui-widgets/components";

import {
  HowItWorksContainer,
  ModalContainer,
  Section,
  SectionContent,
  SectionHeading,
  SectionImage,
  SectionsContainer,
  SectionTag,
  SectionText,
  SectionWrapper,
  Separator,
} from "./EducationProcess.style";
import { ICommonPageData } from "../../pages/InsuranceCommonLanding/types";

interface HowItWorksData {
  pageID: string;
  data: ICommonPageData;
}

interface HowItWorksProps {
  backendData: HowItWorksData;
  allignment?: "center" | "flex-start";
}

const EducationProcess = ({
  backendData,
  allignment,
}: HowItWorksProps) => {
  const data = backendData?.data;

  return (
    <ModalContainer>
      <HowItWorksContainer>
        <SectionHeading>
          <FormattedText value={data?.heading} />
        </SectionHeading>

        <SectionsContainer>
          {data.sections?.map((section, index) => {
            const isEven = index % 2 === 0;
            const isLastSection = index === (data.sections?.length ?? 0) - 1;

            return (
              <SectionWrapper>
                <Section
                  key={index}
                  isEven={isEven}
                  allignment={allignment || "center"}
                >
                  <SectionImage>
                    <ImageComponent
                      src={section.image?.url}
                      width={`${section.image?.width}px`}
                      height={`${section.image?.height}px`}
                      alt={`Step ${index + 1}`}
                    />
                  </SectionImage>

                  <SectionContent>
                    {section.tag && (
                      <SectionTag
                        bgColors={section.tag.styles?.bgColors || ["#000000"]}
                      >
                        <FormattedText value={section.tag.title} />
                      </SectionTag>
                    )}

                    <SectionText>
                      <FormattedText value={section.title} />
                    </SectionText>
                  </SectionContent>
                </Section>
                {!isLastSection && <Separator />}
              </SectionWrapper>
            );
          })}
        </SectionsContainer>
      </HowItWorksContainer>
    </ModalContainer>
  );
};

export default EducationProcess;
